import { CurrentUser } from "../types/CurrentUser";
import { useSignOut } from "./AuthApi";
import useApi from "./hooks/useApi";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const { requestFn } = useApi({
    url: "/user",
    method: "POST",
  });

  return useMutation({
    mutationFn: (data: Omit<CurrentUser, "email" | "id">) => requestFn(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["user"] }),
  });
};

export const useUserData = () => {
  const { requestFn } = useApi<CurrentUser>({
    url: "/user",
    method: "GET",
  });

  return useQuery({
    queryKey: ["user"],
    queryFn: () => requestFn(),
    staleTime: Infinity,
    refetchOnMount: "always",
  });
};

export const useChangePassword = () => {
  const queryClient = useQueryClient();
  const { requestFn } = useApi({
    url: "/user/changePassword",
    method: "POST",
  });

  return useMutation({
    mutationFn: (data: { currentPassword: string; newPassword: string }) => requestFn(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["user"] }),
  });
};

export const useSyncCometChatFriends = () => {
  const { requestFn } = useApi({ url: "/user/sync-friends", method: "POST" });

  return useMutation({ mutationFn: () => requestFn() });
};

export const useDeleteAccount = () => {
  const { requestFn } = useApi({ url: "/user/disable", method: "POST" });
  const { mutate: signOut } = useSignOut();

  return useMutation({ mutationFn: () => requestFn(), onSuccess: () => signOut() });
};
